import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/index')
    },
    {
        path: '/pedimiento',
        name: 'pedimiento',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/pedimiento')
    },
    {
        path: '/verifica',
        name: 'verifica',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/verifica')
    },
    {
        path: '/pecem',
        name: 'Pecem',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/pecem')
    },
     {
        path: '/ccp',
        name: 'Ccp',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/ccp')
    },
]